module.exports = __webpack_public_path__ + "media/notification.11a2be1c.mp3";